export default __webpack_public_path__ + "static/media/undeadchampionslaughterwraith.065755e2.png";